import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import TitlePage from 'components/TituloPage';
import Button from 'components/Button';
import FormPadrao from 'containers/Forms/FormServicoDuvida';
import { fetchStatusModal } from 'store/fetchActions/fetchApp';
import { fetchSalvarInputsFormularios } from 'store/fetchActions/fetchInputForm';
import { publicRoot, requerimentosListarContribuinte, resumoRequerimento } from 'routes/paths';
import { changeInput } from 'utils/formUtils';
import { formatterRequerimentoNull } from 'utils/formatter/requerimento';
import { FORMULARIOS } from 'utils/consts';
import { isValidForSubmit, carregarDadosCadastrais } from '../validations';
import * as S from '../styles';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { reloadVlibras } from 'utils/acessibilidade';

export default function PageDuvidas() {
  const dispatch = useDispatch();
  const history = useHistory();

  const inputDados = useSelector(state => state.inputs.inputDadosRequerimentoCompleto);
  const inputDadosCadastrais = useSelector(state => state.inputs.inputDadosCadastrais);
  const user = useSelector(state => state.sefaz.userProfile);

  const [arquivos, setArquivos] = React.useState(inputDados?.arquivos || { arquivos: [], grid: [] });

  const {
    control,
    setValue,
    getValues,
    watch,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: formatterRequerimentoNull(inputDados?.data),
  });

  React.useEffect(() => {
    reloadVlibras();
  }, [inputDadosCadastrais]);

  React.useEffect(() => {
    dispatch(carregarDadosCadastrais(user, setValue, getValues, inputDados));
    // eslint-disable-next-line
  }, [dispatch, user]);

  const handleChange = e => {
    changeInput(e, setValue, errors, setError);
  };

  const onSubmit = data => {
    dispatch(fetchSalvarInputsFormularios({ data, arquivos, assuntoId: FORMULARIOS.DUVIDAS.id }));
    dispatch(fetchStatusModal(false, ''));
    history.push(resumoRequerimento);
  };

  const onSendFormulario = () => {
    const isValid = dispatch(isValidForSubmit(getValues(), arquivos?.arquivos, setError));
    if (isValid) {
      onSubmit(getValues());
    }
  };

  return (
    <S.Contain className="boxShadow">
      <TitlePage
        textTitle={'FORMULÁRIO DE DÚVIDAS E INFORMAÇÕES GERAIS'}
        backPage={user?.profile === ENUM_TIPO_PERFIL.CONTRIBUINTE ? requerimentosListarContribuinte : publicRoot}
      />
      <form>
        <FormPadrao
          control={control}
          onChange={handleChange}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          watch={watch}
          setError={setError}
          salvarAquivos={setArquivos}
          tipoFormulario={FORMULARIOS.DUVIDAS.id}
          disabled={inputDadosCadastrais}
        />
        <S.ContainButton>
          <Button text={'Avançar'} clickAction={onSendFormulario} css={{ margin: '7px 0px 7px auto' }} />
        </S.ContainButton>
      </form>
    </S.Contain>
  );
}
